import '../../assets/beautrium-css/livechat.scss';
import _ from 'lodash';
import moment from 'moment';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import ReactS3Uploader from 'react-s3-uploader';
import { Link } from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { clearChat, getChat, toggleInputOption, collectCoupon, clearSubmitChat, clearForceOpen } from '../../actions/chat'
import { signinWithCookiePromise } from '../../actions/auth'
import { showAuthenticationPopup, load } from '../../actions/common';
import { moneyFormat } from '../../assets/util'

class LiveChat extends Component {

    constructor(props) {
        super(props);
        this.state = {
            hide: true,
            // no_chat: this.props.oldMsg ? (this.props.oldMsg.login? false: true) : true,
            no_chat: this.props.oldMsg ? false : true,
            // messages: this.props.oldMsg || [],
            messages: this.props.oldMsg || [],
            noReadCount: 0,
            visible: false,
            showImage: null,
            loginCheck: this.props.auth,
            session_id: null,
            collect_coupon: false,
        }
        this.onPreProcess = this.onPreProcess.bind(this)
        this.onSubmitChat = this.onSubmitChat.bind(this);
        this.onSubmitChatPress = this.onSubmitChatPress.bind(this);
        this.renderMessages = this.renderMessages.bind(this);
        this.onReceiveMessage = this.onReceiveMessage.bind(this);
        this.extractMessages = this.extractMessages.bind(this);
        this.joinChannel = this.joinChannel.bind(this);
        this.onInputChange = this.onInputChange.bind(this);
        this.megaMenuHandleClick = this.megaMenuHandleClick.bind(this);
        this.megaMenuHandleOutsideClick = this.megaMenuHandleOutsideClick.bind(this);
        this.onActiveChat = this.onActiveChat.bind(this);
        this.setReadMessages = this.setReadMessages.bind(this);
        this._onInputChange = _.debounce(this.onInputChange, 300);
        this.submitChat = this.submitChat.bind(this);
        this.handleCollectCoupon = this.handleCollectCoupon.bind(this);
        this.chatMsgArea = React.createRef();
    }

    componentDidMount() {
        const { socket, auth, } = this.props; //secret
        if (auth) {
            // console.log("did mount auth")
            this.props.getChat();
            this.joinChannel()
        } else {
            // console.log("did mount")
            // this.props.getChat(secret)
            // this.joinChannel()
            // console.log(this.props.secret)
            // if (!isServer) {
            //     const getChat = this.props.getChat;
            //     const joinChannel = this.joinChannel;
            //     Fingerprint2().get(function(result, components) {
            //         fp = result;
            //         getChat(result);
            //         joinChannel();
            //     });
            // }
        }
        socket.emit('queryChatStatus', (status) => {
            this.setState({ showChat: status })
        })

        socket.on('receive_message', this.onReceiveMessage)
        socket.on('active chat', this.onActiveChat)
        socket.on('error', (error) => {
            // console.log(error)
        });
        socket.on('disconnect', (reason) => {
            if (reason === 'io server disconnect') {
                // the disconnection was initiated by the server, you need to reconnect manually
                socket.connect();
            }
            // else the socket will automatically try to reconnect
        });

        // socket.on('reconnecting', (attemptNumber) => {
        //     console.log("RECONNECTING",attemptNumber)
        //     this.joinChannel()
        //   });

    }

    componentDidUpdate(prevProp, prevState, snapShot) {
        if (!_.isEqual(this.props.oldMsg, prevProp.oldMsg) && this.props.oldMsg) {
            this.setState({ no_chat: this.props.oldMsg.length === 0 ? true : false, messages: this.props.oldMsg })
            if (this.state.hide) {
                const noReadCount = (_.filter(this.props.oldMsg, (m) => (this.props.userid !== m.attributes.user_id && !m.attributes.read))).length
                this.setState({ noReadCount })
            }
        }
        if (prevProp.hide && !this.props.hide) {
            this.setReadMessages();
        }
        if (!this.state.hide) {
            if (this.state.messages && prevState.showImage === this.state.showImage) {
                if (this.state.messages.length > 0) {
                    const el = this.refs.messageContainer;
                    if (el) {
                        el.scrollTop = el.scrollHeight;
                    }
                }
            }
            if (!_.isEqual(this.state.messages, prevState.messages)) {
                this.setReadMessages();
            }
        }
        if (!_.isEqual(this.props.submitMessage, prevProp.submitMessage) && (this.props.submitMessage && this.props.submitMessage.type)) {
            const { type, message } = this.props.submitMessage
            this.submitChat(type, message)
            this.props.clearSubmitChat()
        }
        // if (this.state.messages && !this.state.hide) {
        //     if(this.state.messages.length > 0 ){
        //         if(prevState.showImage === this.state.showImage){
        //             const el = this.refs.messageContainer;
        //             el.scrollTop = el.scrollHeight;
        //         }
        //     }
        // }

        if (prevProp.user === null && this.props.user) {
            // if(prevProp.auth === false && this.props.auth === true){
            // socket.emit('join channel', this.props.userid)
            // console.log("false true")
            if (prevState.collect_coupon) {
                let obj = {
                    message_id: prevState.collect_coupon.message_id,
                    user_id: prevState.collect_coupon.attributes.user_id,
                    promo_id: prevState.collect_coupon.attributes.text.id,
                    status: '01',
                    session_id: prevState.collect_coupon.session,
                    message_text: JSON.stringify(prevState.collect_coupon.attributes.text)
                }
                this.props.collectCoupon(obj, true, this.props.user, this.props.secret)
                this.setState({ collect_coupon: null })
            }

            if (prevProp.oldMsg) {
                // console.log(prevProp.oldMsg[0].session, fp, this.props.user)
                // this.props.mergeChat()
                // mergeChat
            }

            this.joinChannel();
            this.setState({ loginCheck: true, no_chat: false })
            this.props.getChat()
        } else if (prevProp.auth === true && this.props.auth === false) {
            // console.log("true false")
            this.setState({ loginCheck: false, no_chat: true, messages: [] })
            this.props.clearChat();
            // this.joinChannel(prevProp.userid);
            // this.props.getChat(this.props.secret)
        }

        if (prevProp.collect_coupon === null && this.props.collect_coupon === true) {
            this.props.getChat()
        }

        // if (this.props.oldMsg !== prevProp.oldMsg && this.props.oldMsg) {
        //     this.setState({no_chat: false, messages: this.props.oldMsg});
        // }

        if (this.props.forceOpen && !prevProp.forceOpen) {
            this.setState({ hide: false });
            this.props.clearForceOpen();
        }
    }

    joinChannel(prevUserId = -1) {
        const { socket, userid, secret } = this.props;
        // const {session_id} = this.state
        // console.log ("joinChannel", userid, secret, (userid && userid !== -1 && userid !== 1), (secret && (userid === -1 || userid === 1)))
        if (userid && userid !== -1 && userid !== 1) {
            // console.log("AUTH JOIN")
            socket.emit('join channel', userid, secret, (err, session_id) => {
                socket.emit('leave channel', secret)
                this.setState({ session_id })
            });
        } else if (secret && (userid === -1 || userid === 1)) {
            // console.log("FINGER PRINT JOIN")
            socket.emit('join channel', userid, secret, (err, session_id) => {
                socket.emit('leave channel', prevUserId)
                this.setState({ session_id })
            });
        }
    }

    onActiveChat(display) {
        this.setState({ showChat: display })
    }

    onReceiveMessage(data) {
        const newMessages = JSON.parse(JSON.stringify(this.state.messages));
        newMessages.push(data)
        let user_id = 1;
        if (this.props.user) {
            user_id = this.props.user.user_id;
        }
        const noReadCount = (_.filter(newMessages, (m) => !m.attributes.read && m.attributes.user_id !== user_id)).length
        this.setState({ no_chat: data.length === 0, messages: newMessages, noReadCount: this.state.hide ? noReadCount : 0 });
    }

    submitChat(type, message) {
        const { socket, secret, auth, user } = this.props;
        // const {filename, imgUrl} = this.state
        const newMessages = JSON.parse(JSON.stringify(this.state.messages));

        let newMessage = {
            type: type,
            session: this.props.oldMsg.length === 0 ? this.state.session_id : this.props.oldMsg[0].session,
            attributes: {
                user_id: auth ? user.user_id : 1,
                fingerprint: auth ? null : secret,
                img_profile: auth ? user.img_profile : "https://cdn.thebeautrium.com/web-image/dummy.jpg",
                text: message,
                time: moment().format(),
                from: auth ? "customer" : "guest",
                read: false,
                author_name: auth ? user.first_name : "Guest",
                channel: auth ? user.user_id : secret
            }
        }
        socket.emit('stop typing', auth ? user.user_id : secret)
        socket.emit('sent-message', newMessage, auth ? user.user_id : secret, (msgs) => {
            if (Array.isArray(msgs)) {
                msgs.forEach(msg => {
                    newMessages.push(msg)
                })
            } else {
                newMessages.push(msgs)
            }

            const newState = { messages: newMessages, filename: null, no_chat: false }
            if (type === "product" || type === "order") {
                newState.hide = false
            }
            this.setState(prev => newState)
        })
    }

    onSubmitChat(e, value) {
        // const {socket} = this.props;
        const { filename, imgUrl } = this.state
        // console.log("FINGERPRINT", fp)
        if (e.key === "Enter") {
            e.preventDefault();
            if (e.shiftKey) {
                e.target.value = e.target.value + "\n"
                return;
            }
            e.target.value = "";
            this.chatMsgArea.current.value = ""
            if (filename) {
                this.submitChat("image", imgUrl)
            }
            if (value.trim() === "") {
                return;
            } else {
                this.submitChat("message", value)
            }
            this.props.toggleInputOption(false)
        }
    }

    onSubmitChatPress(value) {
        const { filename, imgUrl } = this.state
        this.chatMsgArea.current.value = ""
        if (filename) {
            this.submitChat("image", imgUrl)
        }
        if (value.trim() === "") {
            return;
        } else {
            this.submitChat("message", value)
        }
        this.props.toggleInputOption(false)
    }

    onInputChange(e, value) {
        const { socket, secret } = this.props;
        // console.log(e, value)
        if (value.trim() === "") {
            // console.log (value);
            socket.emit('stop typing', this.props.user ? this.props.user.user_id : secret)
        } else {
            // console.log(this.props.user.user_id)
            socket.emit('typing', this.props.user ? this.props.user.user_id : secret)
        }
    }

    onPreProcess(file, next) {
        // this.props.load(true);
        if (file.size < 10485760) {
            this.props.load(true);
            // this.props.uploading(true);
            next(file);
        } else {
            this.props.load(false);
            this.setState({ fileTooBig: true });
        }
    }

    onUploadFinish(input, signResult, file) {
        this.props.load(false)
        this.setState({ filename: file.name, imgUrl: 'https://api.thebeautrium.com' + signResult.publicUrl, visible: false });
    }

    setReadMessages() {
        const { session_id } = this.state;
        const { user, socket } = this.props;
        let user_id = 1;
        if (user) {
            user_id = user.user_id
        }
        this.setState({ noReadCount: 0 })
        socket.emit('set read message', session_id, moment().format('YYYY-MM-DD HH:mm:ss'), user_id);
    }

    handleCollectCoupon(coupon) {
        let obj = {}
        if (!this.props.auth) {
            this.setState({ collect_coupon: coupon })
            this.props.showAuthenticationPopup(true)
        }

        if (coupon.attributes.text.status !== '00') {
            return null;
        }

        coupon.attributes.text.status = '01'
        obj.message_id = coupon.message_id
        obj.user_id = coupon.attributes.user_id
        obj.promo_id = coupon.attributes.text.id
        obj.status = '01'
        obj.session_id = coupon.session
        obj.message_text = JSON.stringify(coupon.attributes.text)
        if (this.props.user) {
            this.props.collectCoupon(obj, false, this.props.user, this.props.secret)
        }
        // this.props.collectCoupon(obj)

    }

    megaMenuHandleClick() {
        if (!this.state.visible) {
            document.addEventListener('click', this.megaMenuHandleOutsideClick, false);
        } else {
            document.removeEventListener('click', this.megaMenuHandleOutsideClick, false);
        }
        this.setState(prevState => ({
            visible: !prevState.visible
        }))
    }

    megaMenuHandleOutsideClick(e) {
        if (this.inputOption === null || !this.inputOption) {
            return;
        }
        if (this.inputOption.contains(e.target)) {
            return;
        }
        this.megaMenuHandleClick();
    }

    extractMessages(messages) {
        // console.log("EXtract message:", messages)
        let extractedMessages = [];
        let dayMessages = [];
        let prevDate = ``;
        _.forEach(messages, (message, index) => {
            const att = message.attributes;
            let tempDate = att ? moment(att.time).format('DD-MM-YYYY') : null;
            if (prevDate === ``) {
                prevDate = tempDate;
                dayMessages.push(message);
            } else if (prevDate !== tempDate) {
                prevDate = tempDate;
                extractedMessages.push(JSON.parse(JSON.stringify(dayMessages)));
                dayMessages = [];
                dayMessages.push(message);
            } else {
                dayMessages.push(message);
            }

            if (index === messages.length - 1) {
                extractedMessages.push(JSON.parse(JSON.stringify(dayMessages)));
            }
        });
        return extractedMessages;
    }

    renderMessageByType(type, message) {
        if (type === 'image') {
            return (
                <div>
                    <img alt="" src={message.attributes.text} style={{ width: "100px", height: "150px", borderRadius: "10px" }} onClick={(e) => { e.preventDefault(); this.setState({ showImage: message.attributes.text }) }} />
                </div>
            )
        } else if (type === 'message') {
            return (
                <span>
                    <p>{message.attributes.text}</p>
                </span>
            )
        } else if (type === 'coupon') {
            let collected = message.attributes.text.status !== '00'
            return (
                <span className="livechat-message-coupon" onClick={(e) => { e.preventDefault(); this.handleCollectCoupon(message) }}>
                    <span className="coupon-top">
                        <span className="discount">
                            {message.attributes.text.discount_amt ? message.attributes.text.discount_amt + '.-' : message.attributes.text.discount_percent + '%'}
                        </span>
                        <span className="description">
                            <span>{message.attributes.text.desc}</span>
                            <span>{message.attributes.text.min_spend ? 'ขั้นต่ำ ' + moneyFormat(message.attributes.text.min_spend, '฿') : ''}</span>
                            <span>{message.attributes.text.max_cap ? 'ลดสูงสุด ' + moneyFormat(message.attributes.text.max_cap, '฿') : ''}</span>
                            <span>ใช้ได้ถึง {moment(message.attributes.text.end_date).format('DD / MM / YYYY')}</span>
                        </span>
                    </span>
                    <span className="coupon-bottom">
                        <span style={{ margin: " auto 0", fontSize: "14px" }}>CODE: {message.attributes.text.promo_code}</span>
                        <span className={`collect-button ${collected ? "collected" : ""}`}>{collected ? "รับแล้ว" : "รับคูปอง"}</span>
                    </span>
                </span>
            )
        } else if (type === 'product') {
            const productDetail = JSON.parse(message.attributes.text)
            const price = productDetail.mat_price || productDetail.mat_label_price
            return (<span className="message_product_card">
                <Link onClick={() => this.setState({ hide: true })} to={`/item/${productDetail.mat_id}`}>
                    <div className="d-flex align-items-center">
                        <img src={productDetail.image_cart} alt="" />
                        <div className="product-card-detail">
                            <div className="brand">{productDetail.brand_en}</div>
                            <div className="name">{productDetail.mat_name}</div>
                            {productDetail.variant_name_1 && <div className="variant">{productDetail.variant_type_1}: {productDetail.variant_name_1}</div>}
                            {productDetail.variant_name_2 && <div className="variant">{productDetail.variant_type_2}: {productDetail.variant_name_2}</div>}
                            {productDetail.variant_name_3 && <div className="variant">{productDetail.variant_type_3}: {productDetail.variant_name_3}</div>}
                            {productDetail.variant_name_4 && <div className="variant">{productDetail.variant_type_4}: {productDetail.variant_name_4}</div>}
                            {productDetail.variant_name_5 && <div className="variant">{productDetail.variant_type_5}: {productDetail.variant_name_5}</div>}
                            <div className="price">{productDetail.net_price ? moneyFormat(productDetail.net_price, '฿') : ""} <span className={`${productDetail.net_price ? "strike-through" : ""}`}>{moneyFormat(price, '฿')}</span></div>
                        </div>
                    </div>
                </Link>
            </span>
            )
        } else if (type === 'order') {
            const orderDetail = JSON.parse(message.attributes.text)
            return (
                <span className="message_order_card">
                    <Link onClick={() => this.setState({ hide: true })} to={`/order/token/${orderDetail.token}`}>
                        <div className="d-flex align-items-center">
                            <img src={orderDetail.image_product} alt="" />
                            <div className="order-detail">
                                <div className="so_no"><span>หมายเลขคำสั่งซื้อ: </span>{orderDetail.so_no}</div>
                                <div className="status"><span>สถานะ: </span>{orderDetail.doc_status}</div>
                                <div className="price"><span>จำนวนเงิน: </span>{moneyFormat(orderDetail.net_amt, '฿')}</div>
                            </div>
                        </div>
                    </Link>
                </span>
            )
        }
    }

    renderMessages() {
        const { messages } = this.state;
        // console.log("RENDER MESSAGES", messages)
        const extractedMessages = this.extractMessages(messages);
        // console.log(extractedMessages)
        return extractedMessages.map((dayMessages, index) => {
            return (
                <div key={moment(dayMessages[0].attributes.time).format('DD-MM-YYYY')} className="livechat-chat-day">
                    <div className="livechat-chat-day-title">
                        <span>{moment(dayMessages[0].attributes.time).format('DD-MM-YYYY') === moment().format('DD-MM-YYYY') ? "Today" : moment(dayMessages[0].attributes.time).format('DD-MM-YYYY')}</span>
                    </div>
                    {
                        _.map(dayMessages, (message, index) => {
                            const fromAgent = message.attributes.from === "agent"
                            return (
                                <div key={index} className="livechat-message-container livechat-clearfix">
                                    <div className={`livechat-message-wrapper livechat-${fromAgent ? "left livechat-message-agent-wrapper" : "right"} `}>
                                        <div className={`${fromAgent ? "livechat-message-color-wrapper" : ""}`}>
                                            <div className={`livechat-message ${fromAgent ? "" : "livechat-right"}`} style={{ backgroundColor: (fromAgent ? "transparent" : "rgba(61,156,220,0.1)") }}>
                                                <span className={`livechat-message-text ${fromAgent ? "livechat-message-agent-text" : ""}`}>
                                                    {fromAgent && <strong className="livechat-message-agent-author">BEAUTRIUM</strong>}
                                                    {this.renderMessageByType(message.type, message)}
                                                </span>
                                                {/* <div data-arrow-top-tip="Seen" className="livechat-message-sending-status-wrap">
                                                    <svg width="14px" height="10px" viewBox="0 0 16 10" version="1.1" className="livechat-message-sending-status livechat-seen-ico">
                                                        <g id="Helpctrunch-UI-Kit" transform="translate(-627.000000, -1130.000000)"
                                                            fill="#5bd982">
                                                            <g id="Icons" transform="translate(627.000000, 723.000000)">
                                                                <path d="M12.125,407.96875 L7.75,412.3125 L6.78125,411.34375 L11.15625,407 L12.125,407.96875 Z M15.03125,407 L16,407.96875 L7.75,416.1875 L3.9375,412.34375 L4.875,411.375 L7.75,414.21875 L15.03125,407 Z M0,412.34375 L1,411.375 L4.8125,415.21875 L3.84375,416.1875 L0,412.34375 Z" id="seen_icn"></path>
                                                            </g>
                                                        </g>
                                                    </svg>
                                                </div> */}
                                                <span className={`livechat-message-tooltip ${fromAgent ? "livechat-agent" : "livechat-client"}`}>{moment(message.attributes.time).format('ddd, HH:mm')}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )
                        })
                    }
                </div>
            )
        });
    }

    render() {
        const { hide, no_chat, noReadCount, visible } = this.state; //visible
        const { input } = this.props
        // this.props.toggleInputOption(visible)
        if (!this.state.showChat) {
            return (<div></div>);
        } else {
            return (
                <div id="livechat-container">
                    <div>
                        <div className="d-none d-md-flex livechat-status-bar livechat-right livechat-right-icon justify-content-end align-items-end" style={{ zIndex: "1019" }}>
                            {/* <div className="livechat-label-container ">
                                <div style={{ background: "#f40e33" }} className="livechat-label-wrap">
                                    <div className="livechat-label">
                                        <span>ยินดีบริการค่ะ ทักแชทได้เสมอนะคะ</span>
                                        <figure style={{ borderLeftColor: "#f40e33" }} className="livechat-triangle"></figure>
                                    </div>
                                </div>
                            </div> */}
                            <button type="button" className="btn-lg btn-primary btn-circle position-relative" onClick={() => { this.setState({ hide: false }); this.setReadMessages(); }}>
                                <FontAwesomeIcon icon={["fal", "comments"]} />
                                {noReadCount !== 0 && <span className="bg-secondary color-white position-absolute animated infinite slower flash" style={{ top: "-10px", right: "-5px", padding: "5px 10px", borderRadius: "100%", fontWeight: "bold" }}>{noReadCount}</span>}
                            </button>
                        </div>
                        <div className="d-flex d-md-none livechat-status-bar livechat-left livechat-left-icon" style={{ zIndex: "1019" }}>
                            <button type="button" className="btn-lg btn-primary btn-circle position-relative" onClick={() => { this.setState({ hide: false }); this.setReadMessages(); }}>
                                <FontAwesomeIcon icon={["fal", "comments"]} />
                                {noReadCount !== 0 && <span className="bg-secondary color-white position-absolute animated infinite slower flash" style={{ top: "-10px", left: "-5px", padding: "5px 10px", borderRadius: "100%", fontWeight: "bold" }}>{noReadCount}</span>}
                            </button>
                            {/* <div className="livechat-label-container ">
                                <div style={{ background: "#f40e33" }} className="livechat-label-wrap">
                                    <div className="livechat-label">
                                        <span>ยินดีบริการค่ะ ทักแชทได้เสมอนะคะ</span>
                                        <figure style={{ borderLeftColor: "#f40e33" }} className="livechat-triangle"></figure>
                                    </div>
                                </div>
                            </div> */}
                        </div>
                        <div className={`${hide ? "livechat-hide" : ""}`}>
                            <div className={`livechat-chat livechat-state-${no_chat ? 'guest' : 'chat'}`} style={{ backgroundColor: "#D50032", zIndex: "1020" }}>
                                <div className={`livechat-chat-header livechat-state-${no_chat ? 'guest' : 'chat'}`}>
                                    <div className="livechat-logo-wrap">
                                        <div className="livechat-logo-message">BEAUTRIUM</div>
                                    </div>
                                    <div className="livechat-all-agents">
                                        <div className="livechat-chat-online-agents-block livechat-one-agent">
                                            <div className="livechat-avatar-wrap" title="">
                                                <div className="livechat-avatar-view-wrap">
                                                    <figure className="livechat-avatar livechat-avatar-chat livechat-avatar-bg-2 livechat-avatar-bg-gradient">
                                                        <img src={`https://cdn.thebeautrium.com/web-image/Bplus.png`} alt="BEAUTRIUM" />
                                                    </figure>
                                                </div>
                                                <span className="livechat-agent-name">BEAUTRIUM</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="livechat-chat-general-data-wrapper">
                                        <div className="livechat-chat-general-data">
                                            <div className="livechat-chat-general-data-message">ยินดีบริการค่ะ ทักแชทได้เสมอนะคะ</div>
                                            {this.state.loginCheck ? <div className="livechat-chat-online-agents-block livechat-one-agent">
                                                <div className="livechat-avatar-wrap" title="Beautrium Admin">
                                                    <div className="livechat-avatar-view-wrap">
                                                        <figure className="livechat-avatar livechat-avatar-chat livechat-avatar-bg-2 livechat-avatar-bg-gradient">
                                                            <span>BT</span>
                                                        </figure>
                                                    </div>
                                                    <span className="livechat-agent-name">BEAUTRIUM</span>
                                                </div>
                                            </div>
                                                : <div className="livechat-chat-general-data-message" style={{ cursor: "pointer" }}><button className="btn btn-white" type="button" onClick={(e) => { e.preventDefault(); this.props.showAuthenticationPopup(true) }}>เข้าสู่ระบบ หรือ สมัครสมาชิก</button></div>
                                            }
                                            {/* <div className="livechat-chat-online-agents-block livechat-one-agent">
                                                <div className="livechat-avatar-wrap" title="Beautrium Admin">
                                                    <div className="livechat-avatar-view-wrap">
                                                        <figure className="livechat-avatar livechat-avatar-chat livechat-avatar-bg-2 livechat-avatar-bg-gradient">
                                                            <img src={`https://cdn.thebeautrium.com/web-image/Bplus.png`} alt="BEAUTRIUM" />
                                                        </figure>
                                                    </div>
                                                    <span className="livechat-agent-name">BEAUTRIUM</span>
                                                </div>
                                            </div> */}
                                        </div>
                                    </div>
                                    <div className="livechat-btn-close" onClick={() => { this.setState({ hide: true }); }}>
                                        <FontAwesomeIcon icon={["fal", "times"]} style={{ color: "white" }} />
                                    </div>
                                    <div className="livechat-header-bottom-img-wrap">
                                        <div className="livechat-header-bottom-img"></div>
                                    </div>
                                </div>
                                <div className={`livechat-chat-messages-container ${visible ? "input-layer-visible" : ""}`}>
                                    <div id="livechat-message-container" className="livechat-chat-messages" ref="messageContainer">
                                        <span className="livechat-chat-load-more-link livechat-hide">Load more messages</span>
                                        {(this.state.loginCheck && !hide) && this.renderMessages()}
                                        {/* {this.renderMessages()} */}
                                        <noscript></noscript>
                                        <div className="livechat-typing-indicator-component livechat-hide">
                                            <div className="livechat-typing-indicator-wrap">
                                                <div className="livechat-typing-indicator">
                                                    <div className="livechat-dot" style={{ backgroundColor: "rgb(61, 156, 220)" }}></div>
                                                    <div className="livechat-dot" style={{ backgroundColor: "rgb(61, 156, 220)" }}></div>
                                                    <div className="livechat-dot" style={{ backgroundColor: "rgb(61, 156, 220)" }}></div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {this.state.loginCheck && <div className="livechat-chat-message-form">
                                    {/* <div className="livechat-chat-message-form"> */}
                                    <div className="livechat-form-overlay"></div>
                                    <div className="livechat-chat-message-field livechat-state-chat">
                                        <div className="livechat-chat-message-wrapper livechat-clearfix">
                                            {/* <style type="text/css">
                                                
                                            </style> */}
                                            {this.state.filename
                                                &&
                                                <div className="messages__image">
                                                    <div className="messages__image__holder">
                                                        <img alt="" src={this.state.imgUrl} style={{ height: "80px", width: "60px", borderRadius: "10px", boxShadow: "0 0 0 1px rgba(0,0,0,.1), 0 1px 10px rgba(0,0,0,.35)" }}></img>
                                                        <div
                                                            className="img_del"
                                                            onClick={(e) => { e.preventDefault(); this.setState({ filename: null }); }}
                                                        >
                                                            <FontAwesomeIcon icon={["fal", "times"]} style={{ height: "12px", width: "12px", marginTop: "2px", marginLeft: "0px" }} />
                                                        </div>
                                                    </div>
                                                </div>}
                                            <div style={{ maxHeight: "35px" }}>
                                                {visible
                                                    &&
                                                    <div className="chat_input_popup" ref={inputOption => this.inputOption = inputOption} style={{ display: "flex", padding: "10px" }}>
                                                        <div style={{ display: "inline-block", width: "30px", height: "30px", backgroundColor: "#E5E7E9", borderRadius: "4px" }}>
                                                            <input className="" type="hidden" placeholder="" readOnly onClick={(e) => { e.preventDefault(); this.imageUpload.click(); }} />
                                                            <div style={{ width: "20px", margin: "auto", fontSize: "20px", cursor: "pointer" }} onClick={(e) => { e.preventDefault(); this.imageUpload.click(); }}>
                                                                <FontAwesomeIcon icon={["fas", "image"]} />
                                                            </div>
                                                            <label ref={input => this.imageUpload = input}>
                                                                <ReactS3Uploader
                                                                    style={{ display: 'none' }}
                                                                    signingUrl="/s3/sign"
                                                                    signingUrlMethod="GET"
                                                                    accept="image/*"
                                                                    preprocess={this.onPreProcess}
                                                                    onFinish={(signResult, file) => this.onUploadFinish(input, signResult, file)}
                                                                    signingUrlHeaders={{ authorization: localStorage.getItem('token') }}
                                                                    uploadRequestHeaders={{ 'x-amz-acl': 'public-read' }}  // this is the default
                                                                    contentDisposition="auto"
                                                                    scrubFilename={(filename) => moment().format("YYYY-MM-DD_HH-mm") + "-" + filename.replace(/[^\w\d_\-.]+/ig, '')}
                                                                    server={process.env.NODE_ENV === "development" ? "https://api.thebeautrium.com:" : `/ssr`}
                                                                    s3path={`image-chat/`}
                                                                />
                                                            </label>
                                                        </div>
                                                    </div>}
                                            </div>
                                            <div className="livechat-load-file-btn-wrap livechat-load-file-active" onClick={(e) => { e.preventDefault(); this.megaMenuHandleClick() }}>
                                                <svg className="livechat-chat-control" width="16px" height="16px" viewBox="0 0 16 16" version="1.1">
                                                    <g id="Helpctrunch-UI-Kit" transform="translate(-803.000000, -1693.000000)" fill="#3b444f">
                                                        <g id="Buttons" transform="translate(627.000000, 1320.000000)">
                                                            <path d="M184,373 C182.895828,373 181.856776,373.208331 180.882812,373.625 C179.908849,374.041669 179.059899,374.611976 178.335938,375.335938 C177.611976,376.059899 177.041669,376.908849 176.625,377.882812 C176.208331,378.856776 176,379.895828 176,381 C176,382.104172 176.208331,383.143224 176.625,384.117188 C177.041669,385.091151 177.611976,385.940101 178.335938,386.664062 C179.059899,387.388024 179.908849,387.958331 180.882812,388.375 C181.856776,388.791669 182.895828,389 184,389 C185.104172,389 186.143224,388.791669 187.117188,388.375 C188.091151,387.958331 188.940101,387.388024 189.664062,386.664062 C190.388024,385.940101 190.958331,385.091151 191.375,384.117188 C191.791669,383.143224 192,382.104172 192,381 C192,379.895828 191.791669,378.856776 191.375,377.882812 C190.958331,376.908849 190.388024,376.059899 189.664062,375.335938 C188.940101,374.611976 188.091151,374.041669 187.117188,373.625 C186.143224,373.208331 185.104172,373 184,373 L184,373 Z M184,388.015625 C183.031245,388.015625 182.1224,387.830731 181.273438,387.460938 C180.424475,387.091144 179.684899,386.588545 179.054688,385.953125 C178.424476,385.317705 177.924481,384.575525 177.554688,383.726562 C177.184894,382.8776 177,381.968755 177,381 C177,380.031245 177.184894,379.1224 177.554688,378.273438 C177.924481,377.424475 178.424476,376.684899 179.054688,376.054688 C179.684899,375.424476 180.424475,374.924481 181.273438,374.554688 C182.1224,374.184894 183.031245,374 184,374 C184.968755,374 185.8776,374.184894 186.726562,374.554688 C187.575525,374.924481 188.315101,375.424476 188.945312,376.054688 C189.575524,376.684899 190.075519,377.424475 190.445312,378.273438 C190.815106,379.1224 191,380.031245 191,381 C191,381.968755 190.815106,382.8776 190.445312,383.726562 C190.075519,384.575525 189.575524,385.317705 188.945312,385.953125 C188.315101,386.588545 187.575525,387.091144 186.726562,387.460938 C185.8776,387.830731 184.968755,388.015625 184,388.015625 L184,388.015625 Z M187.5,380.5 L184.5,380.5 L184.5,377.5 C184.5,377.364583 184.450521,377.247396 184.351562,377.148438 C184.252604,377.049479 184.135417,377 184,377 C183.864583,377 183.747396,377.049479 183.648438,377.148438 C183.549479,377.247396 183.5,377.364583 183.5,377.5 L183.5,380.5 L180.5,380.5 C180.364583,380.5 180.247396,380.549479 180.148438,380.648438 C180.049479,380.747396 180,380.864583 180,381 C180,381.135417 180.049479,381.252604 180.148438,381.351562 C180.247396,381.450521 180.364583,381.5 180.5,381.5 L183.5,381.5 L183.5,384.5 C183.5,384.635417 183.549479,384.752604 183.648438,384.851562 C183.747396,384.950521 183.864583,385 184,385 C184.135417,385 184.252604,384.950521 184.351562,384.851562 C184.450521,384.752604 184.5,384.635417 184.5,384.5 L184.5,381.5 L187.5,381.5 C187.635417,381.5 187.752604,381.450521 187.851562,381.351562 C187.950521,381.252604 188,381.135417 188,381 C188,380.864583 187.950521,380.747396 187.851562,380.648438 C187.752604,380.549479 187.635417,380.5 187.5,380.5 L187.5,380.5 Z" id="add_flile_icn"></path>
                                                        </g>
                                                    </g>
                                                </svg>
                                                <input type="file" />
                                                <input type="hidden" />
                                            </div>
                                            <textarea ref={this.chatMsgArea} id="livechatChatTextarea" style={{ height: "22px" }} placeholder="Enter your message..." maxLength="3000" onKeyPress={(e) => { this.onSubmitChat(e, e.target.value) }} onChange={(e) => { this._onInputChange(e, e.target.value) }}></textarea>
                                            {/* {this.state.loginCheck && <textarea id="livechatChatTextarea" style={{height: "22px"}} placeholder="Enter your message..." maxLength="3000" 
                                            onKeyPress={(e) => {this.onSubmitChat(e, e.target.value)}} onChange={(e)=> {this._onInputChange(e, e.target.value)}}>
                                            </textarea>} */}
                                            <div className="livechat-chat-control-wrap">
                                                <div className="livechat-chat-send-btn-wrap" onClick={(e) => { this.onSubmitChatPress(this.chatMsgArea.current.value) }} style={{ cursor: "pointer" }}>
                                                    <FontAwesomeIcon icon={['fas', 'paper-plane']} />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                }
                                {this.state.showImage
                                    &&
                                    <div style={{ width: "100vw", height: "100vh", background: "rgba(0, 0, 0, 0.8)", position: "fixed", top: "0", left: "0", zIndex: "1060", padding: "5%", display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center" }} onClick={(e) => { this.setState({ showImage: false }); e.stopPropagation(); }}>
                                        <img alt="" src={this.state.showImage} className="zoominImage" onClick={() => this.setState({ showImage: null })} style={{ width: "80vw" }} />
                                    </div>}
                            </div>
                        </div>
                    </div>
                </div>
            );
        }
    }
}

function mapStateToProps(state) {
    return {
        user: state.prof.profile,
        oldMsg: state.chat.message,
        // inputDisplay: state.chat.inputVisibility,
        auth: state.auth.authenticated,
        userid: state.auth.user_id,
        collect_coupon: state.chat.collect_coupon,
        secret: state.auth.secret,
        submitMessage: state.chat.submitMessage,
        forceOpen: state.chat.forceOpen,
    }
}
export default connect(mapStateToProps, { getChat, toggleInputOption, signinWithCookiePromise, showAuthenticationPopup, collectCoupon, clearSubmitChat, load, clearChat, clearForceOpen })(LiveChat);
// export default connect(mapStateToProps, { getChat, toggleInputOption, signinWithCookiePromise, showAuthenticationPopup })(frontloadConnect(frontLoad, {onMount: true, onUpdate: false})(LiveChat));
